<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.scmInpTempStatus === 'Y' ? 'light' : 'warning'"
          >{{ row.scmInpTempStatusName }}</el-tag
        >
      </template>
      <template v-slot:isVisible="{ row }">
        <el-tag
          size="mini"
          :type="row.isVisible === 'Y' ? 'success' : 'danger'"
          >{{ row.isVisible }}</el-tag
        >
      </template>
      <template v-slot:isMultiselect="{ row }">
        <el-tag
          size="mini"
          :type="row.isMultiselect === 'Y' ? 'success' : 'danger'"
          >{{ row.isMultiselect }}</el-tag
        >
      </template>
      <template v-slot:isRequired="{ row }">
        <el-tag
          size="mini"
          :type="row.isRequired === 'Y' ? 'success' : 'danger'"
          >{{ row.isRequired }}</el-tag
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', { type: 'detail', params: row })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', { type: 'edit', params: row })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.scmInpTempStatus === 'Y'"
          >
            <i
              @click="del(row.scmTemplateCode)"
              class="el-icon-delete tool-btn"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left'
        },
        {
          title: this.$l('form_label_attribute_type_display') || '显示名称',
          field: 'scmInputColumnDisplay',
          minWidth: 140,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title'
        },
        {
          title: this.$l('table_label_column_type') || '字段类型',
          field: 'scmInputColumnTypeName',
          minWidth: 140,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title'
        },
        {
          title: this.$l('table_label_status') || '状态',
          field: 'scmInpTempStatus',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'status' }
        },
        {
          title: this.$l('table_label_is_visible') || '是否显示',
          field: 'isVisible',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'isVisible' }
        },
        {
          title: this.$l('table_label_is_multiSelect') || '是否多选',
          field: 'isMultiselect',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'isMultiselect' }
        },
        {
          title: this.$l('table_label_is_required') || '是否必输项',
          field: 'isRequired',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          slots: { default: 'isRequired' }
        },
        {
          title: this.$l('table_label_sortorder') || '序号',
          field: 'sortOrder',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.table_label_operation') || '操作',
          field: 'col-opt',
          headerAlign: 'center',
          fixed: 'right',
          align: 'center',
          width: 130,
          slots: {
            default: 'opt'
          }
        }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '确认要删除该记录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api
          .scmInputTemplateDelApi({ scmTemplateCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success'
            })
            this.$emit('reload')
          })
      })
    }
  }
}
</script>
